if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          previousButton: this.querySelector('[data-gallery-direction="previous"]'),
          nextButton: this.querySelector('[data-gallery-direction="next"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
        }
        [this.elements.previousButton, this.elements.nextButton].forEach((button) => {
          button?.addEventListener('click', this.onGalleryArrowClick.bind(this));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        this.updateGalleryArrows();
      }

      getMediaItems() {
        if (this.elements.viewer?.sliderItems?.length) {
          return Array.from(this.elements.viewer.sliderItems).filter((item) => item.matches('[data-media-id]'));
        }

        return Array.from(this.elements.viewer.querySelectorAll('li[data-media-id]'));
      }

      onSlideChanged(event) {
        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }
        this.updateGalleryArrows();
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
        this.updateGalleryArrows();
      }

      onGalleryArrowClick(event) {
        event.preventDefault();

        const mediaItems = this.getMediaItems();
        if (mediaItems.length <= 1) return;

        const activeIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
        if (activeIndex === -1) return;

        const direction = event.currentTarget.dataset.galleryDirection;
        const nextIndex = direction === 'next' ? activeIndex + 1 : activeIndex - 1;
        if (nextIndex < 0 || nextIndex >= mediaItems.length) return;

        const nextMediaId = mediaItems[nextIndex].dataset.mediaId;
        const nextThumbnail = this.elements.thumbnails?.querySelector(`[data-target="${nextMediaId}"] button`);

        if (nextThumbnail) {
          nextThumbnail.click();
          return;
        }

        this.setActiveMedia(nextMediaId, false);
      }

      updateGalleryArrows() {
        if (!this.elements.previousButton && !this.elements.nextButton) return;

        const mediaItems = this.getMediaItems();
        const activeIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
        const hasMultipleItems = mediaItems.length > 1;

        if (this.elements.previousButton) {
          this.elements.previousButton.toggleAttribute('disabled', !hasMultipleItems || activeIndex <= 0);
        }

        if (this.elements.nextButton) {
          this.elements.nextButton.toggleAttribute('disabled', !hasMultipleItems || activeIndex === -1 || activeIndex >= mediaItems.length - 1);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
